import React from "react";

export default function PropertiesIcon(props) {
  return(
      <img src="/Icons/properties.svg" alt="properties" {...props}/>
  )
}
